import React from 'react'
import { useTranslation } from 'react-i18next'
import { AnyQuestionsSpan, ScheduleCallLink } from './GlobalNotification/GlobalNotification.styled'
import { HelpCenterModal } from 'Components/Elements/HelpCenterModal/HelpCenterModal'

type ScheduleCallClickProps = {
  isOpen: boolean
  handleScheduleCallClick: () => void
  setModalToShow: (val: boolean) => void
}

export const ScheduleCallClick = ({
  isOpen,
  setModalToShow,
  handleScheduleCallClick,
}: ScheduleCallClickProps) => {
  const { t } = useTranslation('general')
  return (
    <>
      <AnyQuestionsSpan>{t('global_notifications.any_questions')}</AnyQuestionsSpan>
      <ScheduleCallLink href="#" onClick={handleScheduleCallClick}>
        {t('global_notifications.contact_us')}
      </ScheduleCallLink>
      <HelpCenterModal onOpenChange={() => setModalToShow(false)} isOpen={isOpen} />
    </>
  )
}
